
export class GetPersonalDetails {
    public identityId: string;
}
